module.exports = __webpack_public_path__ + "static/media/stm-21st-mobile-822x186-@1x.c1edc502.webp";